module.exports = __webpack_public_path__ + "files/955f33d08a5f48ef8f2f25a7372c7c22.png";